"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TriangleArrowIcon = void 0;
const react_1 = __importDefault(require("react"));
const TriangleArrowIcon = (_a) => {
    var { fill } = _a, props = __rest(_a, ["fill"]);
    return (react_1.default.createElement("svg", Object.assign({ width: "8", height: "5", viewBox: "0 0 8 5", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M4 6.99382e-07L8 5L-8.74228e-07 5L4 6.99382e-07Z", fill: fill })));
};
exports.TriangleArrowIcon = TriangleArrowIcon;
